import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "mentor_request end"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<h2>メンター申請（完了）</h2><div class=\"inner\"><ul class=\"step_4\"><li class=\"off2\">基本入力</li><li class=\"off2\">経歴入力</li><li class=\"off2\">審査問い</li><li class=\"active\">完了<i class=\"fas fa-caret-up step-triangle\"></i></li></ul><div class=\"w_thanks\"><p> メンターのお申し込みありがとうございます。<br class=\"pc\"> ShareMentors事務局にて審査を行います。<br class=\"pc\"> 審査結果はメールにてご連絡します。<br class=\"pc\"> 約1週間程お待ちください。<br class=\"pc\"> なお、非会員の場合、メンターのご申請と同時にフリー会員として登録されます。<br class=\"pc\"> もし、10日以上経過しても審査結果メールが届かない場合には<br class=\"pc\"> お問合せフォームからご連絡ください。<br class=\"pc\"><br> よろしくお願いいたします。 </p></div></div>", 2);
const _hoisted_6 = { class: "bt_home" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'mentor_request_end',
    props: {
        common: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(Link), {
                                    href: "/question",
                                    class: "bt_home"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("ホームに戻る")
                                    ]),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
